(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-order-sample-button"] && !Shopify.designMode) return;
  try {
    (function () {
    if (document.documentElement.dataset.orderSampleBound) return;
    document.documentElement.dataset.orderSampleBound = 'true';

    var LOADING_CLASS = 'loading';
    var HIDDEN_CLASS = 'hidden';

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-sample-button]');
      if (!button) return;
      if (button.classList.contains(LOADING_CLASS)) return;

      event.preventDefault();

      var variantIds = (button.dataset.sampleVariantIds || '')
        .split(',')
        .map(function (id) { return id.trim(); })
        .filter(Boolean);
      if (variantIds.length === 0) return;

      var errorEl = button.parentNode.querySelector('[data-sample-error]');
      if (errorEl) {
        errorEl.classList.add(HIDDEN_CLASS);
        errorEl.textContent = '';
      }

      button.classList.add(LOADING_CLASS);

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: variantIds.map(function (id) { return { id: id, quantity: 1 }; })
        })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, status: response.status, data: data };
          });
        })
        .then(function (result) {
          button.classList.remove(LOADING_CLASS);

          if (!result.ok || result.status >= 400) {
            var message = (result.data && (result.data.description || result.data.message)) || '';
            if (errorEl && message) {
              errorEl.textContent = message;
              errorEl.classList.remove(HIDDEN_CLASS);
            }
            return;
          }

          document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', {
            detail: { items: result.data && result.data.items }
          }));

          var cartIcon = document.querySelector('[data-js-cart-icon]');
          if (cartIcon) cartIcon.click();
        })
        .catch(function () {
          button.classList.remove(LOADING_CLASS);
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
